import { createElement, useMemo } from "react";
import { classNames } from "../../support/formatters/class-formatter";

import type { AllHTMLAttributes, ReactNode } from "react";
import type { Optional } from "../../types";

import styles from "./text.module.css";

export type TextVariants =
  | "web-title-2xlarge"
  | "web-title-xlarge"
  | "web-title-large"
  | "web-title-medium"
  | "web-subtitle-large"
  | "web-subtitle-medium"
  | "body-bold-large"
  | "body-bold-small"
  | "body-bold-xsmall"
  | "body-bold-2xsmall"
  | "body-semibold-medium"
  | "body-semibold-small"
  | "body-semibold-xsmall"
  | "body-semibold-2xsmall"
  | "body-regular-medium"
  | "body-regular-small"
  | "body-regular-xsmall"
  | "web-link-small"
  | "caption-regular-2xsmall";

export type TextProps = {
  as?: Optional<string>;
  variant?: Optional<TextVariants>;
  color?: string;
  children?: ReactNode;
  ellipsis?: boolean;
} & AllHTMLAttributes<HTMLDivElement>;

export function Text({
  as = "p",
  variant = "body-regular-small",
  children,
  color,
  ellipsis,
  className = "",
  ...props
}: TextProps) {
  const mountedClassName = useMemo(() => {
    return classNames(
      variant ? styles[variant] : "",
      ellipsis ? styles.TextOverflow : "",
      className
    );
  }, [variant, className, ellipsis]);

  return createElement(
    as,
    { className: mountedClassName, style: { color }, ...props },
    children
  );
}
